/**
 * Returns a promise that resolves after a certain time (in milliseconds). Basically a promisified setTimeout().
 */

export default async (delay, resolveValue) => {
  return new Promise((resolve) => setTimeout(() => resolve(resolveValue), delay))
}
